import { useState, useEffect } from "react";
import { useUser } from "./Context";
import { downloadFile } from "./Request";

export default function DisplayOsFile({ osID }) {
  const [pdfUrl, setPdfUrl] = useState(null);
  const user = useUser();

  const loadPdf = async () => {
    try {
      const response = await downloadFile(`create-pdf/${osID}`, user.token);
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      setPdfUrl(url);
    } catch (error) {
      console.error("Error retrieving PDF:", error);
    }
  };

  useEffect(() => {
    loadPdf();
  }, []);

  const iframeSrc = pdfUrl ? `${pdfUrl}#zoom=100` : "";

  return (
    <div>
      {pdfUrl ? (
        <iframe src={iframeSrc} width="100%" height="600px" title="PDF Viewer" frameBorder="0" />
      ) : (
        <div>Chargement de l'OS...</div>
      )}
    </div>
  );
}
